/* eslint-disable */
import convertWithTimezone from '../ConvertWithTimezone/DateTimeConvertWithTimezone.support';
import offsetToMinutes from '../OffsetToMinutes/DateTimeOffsetToMinutes.support';

/**
 * Time now using a timezone offset.
 * @param {string} offset The timezone offset (ex. +8:00 or -12:00)
 * @returns {Date} Date and time now
 */
const now = (offset) => {
  return convertWithTimezone(Date.now(), offsetToMinutes(offset));
};

export default now;
